import { useTranslation } from "react-i18next";
import './CalculateButton.css';

export const CalculateButton: React.FC<{ onClick: () => void; disabled?: boolean }> = ({ onClick, disabled = false }) => {
	const { t } = useTranslation('pvt');
	return (<button className="calculate-button" onClick={onClick} disabled={disabled}>
		{t(`calculate`)}
	</button>);
}